module.exports = __webpack_public_path__ + "img/ch-food-consumption.887793c7.jpg";